/* doves & pigeons — dnp-theme.js */

(function () {
  'use strict';

  /* ── MOBILE MENU ──────────────────────────────────────── */
  const menuBtn = document.querySelector('.dnp-header__mobile-menu-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', () => {
      const open = menuBtn.getAttribute('aria-expanded') === 'true';
      menuBtn.setAttribute('aria-expanded', String(!open));
      mobileMenu.setAttribute('aria-hidden', String(open));
    });
  }

  /* ── CART COUNT SYNC ──────────────────────────────────── */
  function updateCartCount(count) {
    document.querySelectorAll('.dnp-cart-count').forEach(el => {
      el.textContent = count;
    });
  }

  /* ── ADD TO CART (product card quick-add) ─────────────── */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    const original = btn.textContent;
    btn.textContent = 'adding...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error('add failed');
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      updateCartCount(cart.item_count);
      btn.textContent = 'added!';
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1500);
    } catch (err) {
      btn.textContent = 'error';
      setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1500);
    }
  });

  /* ── PRODUCT PAGE ─────────────────────────────────────── */
  const productForm = document.getElementById(
    document.querySelector('[id^="product-form-"]')?.id
  );

  // Variant selection
  document.querySelectorAll('.dnp-variant-radio').forEach(radio => {
    radio.addEventListener('change', () => {
      const index = parseInt(radio.dataset.optionIndex);
      const val = radio.value;

      // Update selected label
      const label = document.getElementById(`option-${index}-value`);
      if (label) label.textContent = val;

      // Mark option selected
      radio.closest('.dnp-variant-options').querySelectorAll('.dnp-variant-option').forEach(opt => {
        opt.classList.remove('dnp-variant-option--selected');
      });
      radio.closest('.dnp-variant-option').classList.add('dnp-variant-option--selected');

      // Find matching variant
      if (!window.productData) return;
      const selections = [];
      document.querySelectorAll('.dnp-variant-group').forEach(group => {
        const checked = group.querySelector('.dnp-variant-radio:checked');
        if (checked) selections.push(checked.value);
      });

      const match = window.productData.variants.find(v =>
        v.options.every((opt, i) => opt === selections[i])
      );

      if (match) {
        const variantInput = document.getElementById('variant-id');
        if (variantInput) variantInput.value = match.id;

        const priceEl = document.querySelector('.dnp-product__price-current');
        if (priceEl) priceEl.textContent = formatMoney(match.price);

        const addBtn = document.getElementById('add-to-cart-btn');
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? 'add to cart' : 'sold out';
        }
      }
    });
  });

  // Quantity buttons
  document.querySelectorAll('[data-quantity-minus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.dnp-quantity').querySelector('.dnp-quantity__input');
      if (parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
    });
  });
  document.querySelectorAll('[data-quantity-plus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.dnp-quantity').querySelector('.dnp-quantity__input');
      input.value = parseInt(input.value) + 1;
    });
  });

  // Product image thumbnails
  document.querySelectorAll('.dnp-product__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.src;
      const mainImg = document.getElementById('main-product-image');
      if (mainImg && src) mainImg.src = src;
      document.querySelectorAll('.dnp-product__thumb').forEach(t => {
        t.classList.remove('dnp-product__thumb--active');
      });
      thumb.classList.add('dnp-product__thumb--active');
    });
  });

  // Product form submit (add to cart)
  const addBtn = document.getElementById('add-to-cart-btn');
  if (addBtn) {
    addBtn.closest('form')?.addEventListener('submit', async (e) => {
      e.preventDefault();
      const form = e.target;
      const formData = new FormData(form);
      const status = document.getElementById('cart-status');

      addBtn.disabled = true;
      addBtn.textContent = 'adding...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });
        if (!res.ok) {
          const err = await res.json();
          throw new Error(err.description || 'Could not add to cart');
        }
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        updateCartCount(cart.item_count);
        addBtn.textContent = 'added!';
        if (status) { status.textContent = 'added to cart.'; }
        setTimeout(() => {
          addBtn.disabled = false;
          addBtn.textContent = 'add to cart';
          if (status) status.textContent = '';
        }, 2000);
      } catch (err) {
        if (status) status.textContent = err.message;
        addBtn.disabled = false;
        addBtn.textContent = 'add to cart';
      }
    });
  }

  // Accordions
  document.querySelectorAll('.dnp-accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));
      const body = document.getElementById(trigger.getAttribute('aria-controls'));
      if (body) body.hidden = expanded;
      const icon = trigger.querySelector('.dnp-accordion__icon');
      if (icon) icon.textContent = expanded ? '+' : '−';
    });
  });

  /* ── CART PAGE ────────────────────────────────────────── */
  // Cart item quantity update
  document.querySelectorAll('.dnp-quantity__btn[data-item-key]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.itemKey;
      const action = btn.dataset.action;
      const input = document.querySelector(`.dnp-quantity__input[data-item-key="${key}"]`);
      if (!input) return;
      const qty = parseInt(input.value) + (action === 'plus' ? 1 : -1);
      if (qty < 0) return;
      input.value = Math.max(0, qty);
      await updateCartItem(key, Math.max(0, qty));
    });
  });

  // Cart item remove
  document.querySelectorAll('.dnp-cart-item__remove').forEach(btn => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.itemKey;
      await updateCartItem(key, 0);
      const item = btn.closest('.dnp-cart-item');
      if (item) item.remove();
    });
  });

  async function updateCartItem(key, qty) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      const cart = await res.json();
      updateCartCount(cart.item_count);
      const subtotal = document.getElementById('cart-subtotal');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    } catch (err) {
      console.error('Cart update error', err);
    }
  }

  /* ── FILTERS (collection page) ───────────────────────── */
  const filterForm = document.getElementById('FacetFiltersForm');
  if (filterForm) {
    filterForm.querySelectorAll('input[type="checkbox"]').forEach(cb => {
      cb.addEventListener('change', () => filterForm.submit());
    });
  }

  /* ── SORT (collection page) ──────────────────────────── */
  document.querySelector('[data-sort]')?.addEventListener('change', (e) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    window.location.href = url.toString();
  });

  /* ── RECENTLY VIEWED ─────────────────────────────────── */
  const VIEWED_KEY = 'dnp_recently_viewed';
  const MAX_VIEWED = 6;

  function getViewed() {
    try { return JSON.parse(localStorage.getItem(VIEWED_KEY)) || []; }
    catch { return []; }
  }
  function saveViewed(items) {
    try { localStorage.setItem(VIEWED_KEY, JSON.stringify(items)); } catch {}
  }

  // On product pages, save current product
  if (window.productData) {
    const p = window.productData;
    let viewed = getViewed().filter(v => v.id !== p.id);
    viewed.unshift({
      id: p.id,
      title: p.title.toLowerCase(),
      url: window.location.pathname,
      price: p.price,
      image: p.featured_image ? p.featured_image.src : null
    });
    saveViewed(viewed.slice(0, MAX_VIEWED));
  }

  // On non-product pages, render recently viewed in sidebar
  const rvPanel = document.getElementById('recently-viewed-panel');
  const rvContainer = document.getElementById('recently-viewed-items');
  if (rvPanel && rvContainer && !window.productData) {
    const viewed = getViewed();
    if (viewed.length > 0) {
      rvPanel.style.display = 'block';
      viewed.slice(0, 3).forEach(item => {
        const el = document.createElement('a');
        el.href = item.url;
        el.className = 'dnp-thumb';
        const imgSrc = item.image
          ? item.image.replace(/(\.[^.]+)$/, '_120x$1')
          : null;
        el.innerHTML = `
          ${imgSrc
            ? `<img src="${imgSrc}" alt="${item.title}" class="dnp-thumb__img" width="44" height="44" loading="lazy">`
            : `<div class="dnp-thumb__placeholder">${item.title.slice(0,1)}</div>`
          }
          <div class="dnp-thumb__info">
            <div class="dnp-thumb__name">${item.title}</div>
            <div class="dnp-thumb__price">${formatMoney(item.price)}</div>
          </div>`;
        rvContainer.appendChild(el);
      });
    }
  }

  /* ── UTILITIES ────────────────────────────────────────── */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

})();
